export const SPACEBAR_KEY_CODE = [0, 32];

export const ENTER_KEY_CODE = 13;

export const DOWN_ARROW_KEY_CODE = 40;

export const UP_ARROW_KEY_CODE = 38;

export const ESCAPE_KEY_CODE = 27;
